import { MaterialManager } from "./materialManager.ts";
type SingletonClassName = "MaterialManager";

// singletonInitializer.ts
export class SingletonManager {
  private static instances: Map<SingletonClassName, any> = new Map();

  public static isInitialized = false;
  static initializeAll(): void {
    if (this.isInitialized) {
      console.log(" Singleton is already initialized");

      return;
    }
    this.isInitialized = true;

    this.instances.set("MaterialManager", new MaterialManager());
  }

  static get materialManager(): MaterialManager {
    return this.instances.get("MaterialManager");
  }
}
